(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/xperten.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/xperten.js'); 
svs.tipset.views.Xperten = Backbone.Marionette.View.extend({
  className: 'modal-bottom-padding span12 centered align-center',
  tagName: 'div',
  events: {
    'click .js-btn-xperten': 'onXpertenClick',
    'click .js-btn-show-extended': 'onShowExtendedClick',
    'click .js-btn-xperten-create-row': 'onCreateRowClick',
    'change .js-btn-xperten-use-row': 'onUseRowClick',
    'click .js-help-dialog-board-row': 'helpDialogBoardRow'
  },

  modelEvents: {
    updateXperten: 'render'
  },
  system: null,
  showExtended: false,
  extendedButtons: [],

  template: function(data) {
    return svs.tipset.templates.xperten(data);
  },

  initialize: function(data) {
    this.uid = svs.tipset.getUid();
    this.model.setData();
    if (
      this.model.getCurrentSystem() &&
      this.hasClickedAndValid(data.model.attributes.systemsToShow)
    ) {
      $('.modal-button-right').prop('disabled', false);
    }
  },

  onXpertenClick: function(e) {
    $('.modal-button-right').prop('disabled', false);
    this.model.setCurrentSystem($(e.currentTarget).data('object'));
  },

  hasClickedAndValid: function(system) {
    for (var s in system) {
      if (system[s].isClicked && system[s].isValid) return true;
    }
    return false;
  },

  xpertenDone: function() {
    this.model.getSystem();
  },

  onCreateRowClick: function(e) {
    this.model.setUseBoardRow($('.js-btn-xperten-create-row').prop('checked'));
    e.currentTarget.offsetHeight; 
  },

  onUseRowClick: function() {
    var isCompetition =
      svs.tipset.models.competition &&
      svs.tipset.models.competition.getCompetitionMode();
    this.useBoardRow = $('.js-btn-xperten-use-row').prop('checked');
    this.model.setUseBoardRow($('.js-btn-xperten-use-row').prop('checked'));
    this.model.setIsValid();

    if (svs.tipset.models.play.get('isSingleRow')) {
      $('.js-btn-xperten').each(function() {
        $(this).prop('disabled', false);
      });
    } else {
      var fullHedges = svs.tipset.collections.matchlist
        ? svs.tipset.collections.matchlist.getNrOfFullHedges()
        : 0;
      var halfHedges = svs.tipset.collections.matchlist
        ? svs.tipset.collections.matchlist.getNrOfHalfHedges()
        : 0;
      var useBoardRow = this.useBoardRow;

      $('.js-btn-xperten').each(function() {
        $(this).prop('disabled', false);
        if (useBoardRow) {
          if (isCompetition) {
            if (
              $(this).data('object').size !==
                svs.tipset.constants.M_SYSTEM.M_64 ||
              ($(this).data('object').full < fullHedges ||
                $(this).data('object').half < halfHedges)
            ) {
              $(this).prop('disabled', true);
            }
          } else if (
            $(this).data('object').full < fullHedges ||
            $(this).data('object').half < halfHedges
          ) {
            $(this).prop('disabled', true);
          }
          if ($(this).prop('checked')) {
            $(this).prop('checked', false);
            this.system = null;
            $('.modal-button-right').prop('disabled', true);
          }
        } else if (isCompetition) {
          $(this).prop(
            'disabled',
            $(this).data('object').size !== svs.tipset.constants.M_SYSTEM.M_64
          );
        }
      });
    }
  },

  onShowExtendedClick: function() {
    this.showExtended = !this.showExtended;

    if (!this.extendedButtons.length) {
      this.extendedButtons = this.$el.find('.extended');
    }

    if (this.showExtended) {
      this.extendedButtons.removeClass('hide');
      this.$el
        .find('.xperten-show-all i')
        .removeClass('icon-menu-down')
        .addClass('icon-menu-up');
    } else {
      this.extendedButtons.addClass('hide');
      this.$el
        .find('.xperten-show-all i')
        .removeClass('icon-menu-up')
        .addClass('icon-menu-down');
    }
    this.$el.find('.panel-footer span').toggle();

    this.trigger('modalContentResize');
  },

  helpDialogBoardRow: function(e) {
    if (svs.tipset.data.config.helpTexts) {
      var _dialog = new svs.components.dialog.Contextual({
        branding: svs.components.dialog.branding.SPORT,
        attachTo: $(e.currentTarget),
        zIndex: 1400,
        title: svs.tipset.data.config.helpTexts.xperten_board_row.title,
        message: [
          {
            type: svs.components.dialog.message.TEXT,
            text: svs.tipset.data.config.helpTexts.xperten_board_row.body
          }
        ]
      });
      svs.components.dialog.api.add(_dialog);
    }
  },

  reset: function() {
    var system = this.isRsystem
      ? svs.tipset.models.xpertenSystems.getRsystem()
      : svs.tipset.models.xpertenSystems.getSystems(
        svs.tipset.models.gameDefinitions.get('numberOfMatches')
      );

    Object.keys(system).forEach(function(s) {
      system[s].isClicked = false;
    });
  }
});

 })(window);